import React from "react";
interface ContainerProps {
  children: React.ReactNode;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  ({ children, className = '', onClick }, ref) => {
    return (
      <div ref={ref} className={`container ${className}`} onClick={onClick}>
        {children}
      </div>
    );
  }
);